import { Component, OnInit } from "@angular/core";
import { JsLoaderService } from "src/shared/services/js-loader.service";

@Component({
  selector: "app-demographics",
  templateUrl: "./demographics.component.html"
})
export class DemographicsComponent implements OnInit {
  constructor(private jsLoader: JsLoaderService) {
    this.jsLoader.loadScripts();
  }

  ngOnInit() {}
}
